/**
 * @file: DeptSafeConfig.
 * @authors: fjxhx.
 * @createDate: 2022.
 * @Description: 食堂安全人员配置
 */
import request from '@/utils/request'

/**
 * 查看食堂安全人员配置(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deptsafeconfigGet(data) {
  return request({
    type: 'biz',
    url: 'deptsafeconfig/get',
    method: 'post',
    data
  })
}

/**
 * 查看食堂安全人员配置(包含头像)(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deptsafeconfigImgGet(data) {
  return request({
    type: 'biz',
    url: 'deptsafeconfig/img/get',
    method: 'post',
    data
  })
}

/**
 * 查看食堂安全人员配置(包含头像)(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deptsafeconfigImgNotokenGet(data) {
  return request({
    type: 'biz',
    url: 'deptsafeconfig/img/notoken/get',
    method: 'post',
    data
  })
}

/**
 * 获取食堂负责人列表(liurl)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deptsafeconfigLeaderListGet(data) {
  return request({
    type: 'biz',
    url: 'deptsafeconfig/leader/list/get',
    method: 'post',
    data
  })
}

/**
 * 获取食堂安全人员列表(分页)(wrp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deptsafeconfigListGet(data) {
  return request({
    type: 'biz',
    url: 'deptsafeconfig/list/get',
    method: 'post',
    data
  })
}

/**
 * PC端查看三大员的个人详细信息(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deptsafeconfigPcGet(data) {
  return request({
    type: 'biz',
    url: 'deptsafeconfig/pc/get',
    method: 'post',
    data
  })
}

/**
 * 编辑食堂安全人员配置(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deptsafeconfigSave(data) {
  return request({
    type: 'biz',
    url: 'deptsafeconfig/save',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/DeptSafeConfig.js